import { pluralize } from "utils/date-format";
import { CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME } from "models/generateCustomAttributesSchema";
import {
  FormConfiguration,
  FormSection,
  FormModeAdapter,
  SubmissionContext,
} from "./definitions";

/**
 * Base adapter class with sensible defaults
 * Specific adapters can extend this and override only the methods they need to customize
 */
export abstract class BaseFormModeAdapter implements FormModeAdapter {
  // UI Configuration methods
  getFormConfig(): FormConfiguration {
    return {
      // UI Visibility
      showMainForm: true,
      showTemplates: false,
      showFileUpload: false,
      showContacts: true,

      // Navigation
      enableNavigation: true,
    };
  }

  shouldShowSection(section: FormSection): boolean {
    const config = this.getFormConfig();

    switch (section) {
      case FormSection.MAIN_FORM:
        return config.showMainForm;
      case FormSection.TEMPLATES:
        return config.showTemplates;
      case FormSection.FILE_UPLOAD:
        return config.showFileUpload;
      case FormSection.CONTACTS:
        return config.showContacts;
      default:
        return false;
    }
  }

  shouldLoadGaiaObject(): boolean {
    return false;
  }

  shouldLoadScanResult(): boolean {
    return false;
  }

  shouldLoadScanJob(): boolean {
    return false;
  }

  abstract handleSubmit(data: any, context: SubmissionContext): Promise<void>;

  getGuestLoaderId(shortId?: string): string {
    return this.shouldLoadScanResult() ? "" : shortId || "";
  }

  getSubmitButtonText(): string {
    return "Create";
  }

  /**
   * Get default form values
   * Provides default values for country and status custom attributes
   * Subclasses can override if they need different behavior
   */
  getDefaultFormValues(
    defaultCountry: string,
    defaultStatus: string
  ): Record<string, any> {
    return {
      [CUSTOM_ATTRIBUTES_DATA_MAP_KEY_NAME]: {
        country: defaultCountry,
        status: defaultStatus,
      },
    };
  }

  shouldPersistFormData(shortId?: string): boolean {
    return false;
  }

  getSuccessRedirectPath(type: string, shortId?: string): string {
    return `/${pluralize(type)}`;
  }

  getCancelRedirectPath(type: string, shortId?: string): string {
    return `/drafts`;
  }
}
